var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      attrs: {
        "data-backdrop": "static",
        tabindex: "-1",
        role: "dialog",
        "aria-hidden": "true"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-scrollable modal-xl",
          attrs: { role: "document" }
        },
        [
          _vm.equipment && _vm.test
            ? _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _vm.editable && (!_vm.equipment || !_vm.equipment.id)
                    ? _c("h5", { staticClass: "modal-title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("testEquipment.test.modal.nameNew"))
                        )
                      ])
                    : _c("h5", { staticClass: "modal-title" }, [
                        _vm._v(_vm._s(_vm.$t("testEquipment.test.modal.name")))
                      ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button", "aria-label": "Close" },
                      on: { click: _vm.dismiss }
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×")
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-body" },
                  [
                    _c("TestEquipmentTestEdit", {
                      attrs: {
                        equipment: _vm.equipment,
                        test: _vm.test,
                        editable: _vm.editable
                      },
                      on: { fileAdded: _vm.fileAdded }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.dismiss }
                    },
                    [_vm._v(_vm._s(_vm.$t("testEquipment.test.modal.close")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: {
                        type: "button",
                        disabled: !_vm.canSave || _vm.saving
                      },
                      on: { click: _vm.save }
                    },
                    [
                      _vm.saving
                        ? _c("Spinner", { attrs: { small: true } })
                        : _vm._e(),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("testEquipment.test.modal.save")) +
                          "\n        "
                      )
                    ],
                    1
                  )
                ])
              ])
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }